'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Spinner = function Spinner(_ref) {
    var show = _ref.show;
    return _react2.default.createElement(
        'div',
        { className: 'Spinner' },
        _react2.default.createElement(
            'div',
            { className: 'spinner-wrapper' },
            _react2.default.createElement(
                'div',
                { className: 'spinner-container' },
                _react2.default.createElement(
                    'svg',
                    { className: 'circular', viewBox: '25 25 50 50' },
                    _react2.default.createElement('circle', { className: 'path spinner-line',
                        cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
                )
            )
        )
    );
};

var SpinnerContainer = function SpinnerContainer(props) {
    var show = props.show,
        fadeIn = props.fadeIn;


    if (fadeIn) {
        return _react2.default.createElement(
            _CSSTransitionGroup2.default,
            {
                transitionName: 'fade',
                transitionEnterTimeout: 200,
                transitionLeaveTimeout: 200 },
            show ? _react2.default.createElement(Spinner, null) : null
        );
    }

    return show ? _react2.default.createElement(Spinner, null) : null;
};

Spinner.propTypes = SpinnerContainer.propTypes = {
    show: _propTypes2.default.bool,
    fadeIn: _propTypes2.default.bool
};

exports.default = SpinnerContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/loaders/Spinner.js
// module id = 65
// module chunks = 0